import { LunchPolicyActions } from 'src/store/actions/lunchPolicyActions';
const initialState = {
    data: null,
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case LunchPolicyActions.GET_LUNCH_POLICY_REQUEST: {
            return {
                ...state,
                loading: true
            };
        }
        case LunchPolicyActions.GET_LUNCH_POLICY_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: payload?.Data ?? null
            };
        }
        case LunchPolicyActions.CREATE_OR_UPDATE_LUNCH_POLICY_SUCCESS: {
            const item = payload?.Data || null;
            if (!item) {
                return { ...state, loading: false };
            }
            const list = state.data || [];
            const idx = list.findIndex((x) => x.Id === item.Id);
            const next = idx >= 0 ? [...list.slice(0, idx), item, ...list.slice(idx + 1)] : [item, ...list];
            return {
                ...state,
                loading: false,
                data: next
            };
        }
        case LunchPolicyActions.DELETE_LUNCH_POLICY_SUCCESS: {
            const item = payload?.Data || null;
            if (!item) {
                return { ...state, loading: false };
            }
            const list = state.data || [];
            const next = list.filter((x) => x.Id !== item.Id);
            return {
                ...state,
                loading: false,
                data: next
            };
        }
        case LunchPolicyActions.GET_LUNCH_POLICY_FAIL: {
            return {
                ...state,
                loading: false
            };
        }
        default:
            return state;
    }
};
